import { useCallback, useEffect, useState } from 'react'
import { apiClient, buildAuthRequestConfig, getAuthToken } from '../utils/apiClient';

const useFetch = (url,autoLoad=true) => {
    const [data,setData] = useState(null);
    const [loading,setLoading] = useState(Boolean(autoLoad && url));
    const [error,setError]  = useState(null);

    const fetchData = useCallback(async ()=>{
        try {
            if (!url) {
                setData(null);
                setError(null);
                setLoading(false);
                return;
            }

            const token = getAuthToken();
            if (!token) {
                setData(null);
                setError(null);
                setLoading(false);
                return;
            }

            setLoading(true);
            const response = await apiClient.get(url, buildAuthRequestConfig());
            setError(null);
            setData(response.data);
            setLoading(false);
        }catch(error){
            setError(error);
            setLoading(false);
        }
    }, [url]);

    const refreshHandler = useCallback(() => {
        fetchData();
    }, [fetchData])

    useEffect(()=>{
        if(autoLoad){
            fetchData();
            return () => {
                // Cleanup or cancel ongoing requests if needed
            }
        } else {
            setLoading(false);
        }
    }, [autoLoad, fetchData])

    return {data,loading,error,fetchData,refreshHandler}
}

export default useFetch
